package com.vizio.redwolf.consent.api

import com.vizio.redwolf.consent.model.ARTokenState
import com.vizio.redwolf.utils.ResponseHeaders
import kotlin.js.JsExport

@JsExport
sealed class ConsentV2Result<out T : Any> {
    data class Success<out T : Any>(val headers: ResponseHeaders, val data: T, val tokenState: ARTokenState) : ConsentV2Result<T>()
    data class NeedsReLogin(val headers: ResponseHeaders, val message: String) : ConsentV2Result<Nothing>()   // Bad Request
    data class Failed(val headers: ResponseHeaders, val message: String) : ConsentV2Result<Nothing>()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : ConsentV2Result<Nothing>()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : ConsentV2Result<Nothing>()

    fun <R> fold(
        onSuccess: (success: Success<T>) -> R,
        onNeedsReLogin: (needsReLogin: NeedsReLogin) -> R,
        onFailed: (failed: Failed) -> R,
        onError: (error: Error) -> R,
        onTimeout: (timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Success -> onSuccess(Success(this.headers, this.data, this.tokenState))
            is NeedsReLogin -> onNeedsReLogin(NeedsReLogin(this.headers, this.message))
            is Failed -> onFailed(Failed(this.headers, this.message))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}